import { Vector3 } from "@babylonjs/core";
import { path2 } from "@jscad/modeling/src/geometries";
import { expand } from "@jscad/modeling/src/operations/expansions";

export default class ProfilePointsGenerator {
    public static getVeeNotchPoints() {
        return [
            new Vector3(-0.2661, 0, 2.75),
            new Vector3(-0.1875, 0, 0.5),
            new Vector3(-0.0625, 0, 0.375),
            new Vector3(-0.0625, 0, 0),
            new Vector3(0.0625, 0, 0),
            new Vector3(0.0625, 0, 0.375),
            new Vector3(0.1875, 0, 0.5),
            new Vector3(0.2661, 0, 2.75)
        ];
    }

    public static getLtNotchPoints() {
        return [
            new Vector3(-0.7167, 2.75, 0),
            new Vector3(-0.655556, 1, 0),
            new Vector3(-0.530556, 0.875, 0),
            new Vector3(-0.5, 0, 0),
            new Vector3(0.5, 0, 0),
            new Vector3(0.530556, 0.875, 0),
            new Vector3(0.655556, 1, 0),
            new Vector3(0.7167, 2.75, 0)
        ];
    }

    public static getSlipAndDriveConnectorPoints(materialThickness: number) {
        let sdPathCenter = path2.fromPoints({}, [[0, 0]]);
        sdPathCenter = path2.appendArc({ endpoint: [0, 0.1078], radius: [0.0539, 0.0539], clockwise: true }, sdPathCenter);
        sdPathCenter = path2.appendPoints([[0.5, 0.1078]], sdPathCenter);

        let { sides } = expand({ delta: materialThickness }, sdPathCenter);

        const points = sides.map(s => s[0]);

        points.push(sides[sides.length - 1][1]);

        return points;
    }

    public static getTdcConnectorPoints(materialThickness: number) {
        let tdcPathCenter = path2.fromPoints({}, [[0, 0]]);
        tdcPathCenter = path2.appendArc({ endpoint: [-0.0596, -0.02], radius: [0.0988, 0.0988] }, tdcPathCenter);
        tdcPathCenter = path2.appendPoints([[-0.0922, -0.0447]], tdcPathCenter);
        tdcPathCenter = path2.appendArc({ endpoint: [-0.123, -0.055], radius: [0.051, 0.051], clockwise: true }, tdcPathCenter);
        tdcPathCenter = path2.appendPoints([[-0.2432, -0.055]], tdcPathCenter);
        tdcPathCenter = path2.appendArc({ endpoint: [-0.2942, -0.004], radius: [0.051, 0.051], clockwise: true }, tdcPathCenter);
        tdcPathCenter = path2.appendPoints([[-0.2942, 1.1196]], tdcPathCenter);
        tdcPathCenter = path2.appendArc({ endpoint: [-0.2479, 1.1704], radius: [0.051, 0.051], clockwise: true }, tdcPathCenter);
        tdcPathCenter = path2.appendPoints([[-0.1272, 1.1803]], tdcPathCenter);
        tdcPathCenter = path2.appendArc({ endpoint: [-0.1002, 1.1677], radius: [0.03, 0.03], clockwise: true }, tdcPathCenter);
        tdcPathCenter = path2.appendArc({ endpoint: [-0.0467, 1.2829], radius: [0.0733, 0.0733], clockwise: false, large: true }, tdcPathCenter);
        tdcPathCenter = path2.appendPoints([[-0.2466, 1.2664]], tdcPathCenter);

        let sides = expand({ delta: materialThickness }, tdcPathCenter).sides;

        const points = sides.map(s => s[0]);

        points.push(sides[sides.length - 1][1]);

        return points;
    }
}